import { IStateOffer, IStateOffers } from "@/apps/merchant3/models/IOfferV2";
import { IPaymentTermsV2 } from "@/apps/merchant3/models/IOffer";

export default {
  namespaced: true,
  state: { offers: [] } as IStateOffers,
  mutations: {
    SET_OFFERS: (state: IStateOffers, payload: IStateOffer[]): void => {
      state.offers = payload;
    },
    UPDATE_PRICE: (
      state: IStateOffers,
      { id, price }: { id: number; price: number }
    ): void => {
      const offer = state.offers.find((offer) => offer.productId == id);

      if (offer) {
        offer.price = price;
        offer.downPayment = null;
        offer.minDownPayment = null;
        offer.maxDownPayment = null;
        offer.months = null;
        offer.terms = null;
      }
    },
    UPDATE_DOWNPAYMENT: (
      state: IStateOffers,
      {
        id,
        downPayment,
        minDownPayment,
        maxDownPayment,
      }: {
        id: number;
        downPayment?: number | null;
        minDownPayment?: number | null;
        maxDownPayment?: number | null;
      }
    ): void => {
      const offer = state.offers.find((offer) => offer.productId == id);

      if (offer) {
        offer.downPayment = downPayment;
        offer.minDownPayment = minDownPayment;
        offer.maxDownPayment = maxDownPayment;
        offer.months = null;
        offer.terms = null;
      }
    },
    UPDATE_TERMS: (
      state: IStateOffers,
      { id, terms }: { id: number; terms?: IPaymentTermsV2[] | null }
    ): void => {
      const offer = state.offers.find((offer) => offer.productId == id);

      if (offer) {
        offer.terms = terms;
      }
    },
    UPDATE_MONTHS: (
      state: IStateOffers,
      { id, months }: { id: number; months?: number | null }
    ): void => {
      const offer = state.offers.find((offer) => offer.productId == id);

      if (offer) {
        offer.months = months;
      }
    },
    UPDATE_FIRST_PAYMENT_DATE: (
      state: IStateOffers,
      { id, firstPaymentDate }: { id: number; firstPaymentDate?: number | null }
    ): void => {
      const offer = state.offers.find((offer) => offer.productId == id);

      if (offer) {
        offer.firstPaymentDate = firstPaymentDate;
      }
    },
    UPDATE_SELECTED_VARIANT: (
      state: IStateOffers,
      { id, variantId }: { id: number; variantId?: number | null }
    ): void => {
      const offer = state.offers.find((offer) => offer.productId == id);

      if (!offer) return;

      const variant = offer.variants?.find(
        (variant) => variant.id === variantId
      );

      if (!variant) {
        offer.selectedVariantId = null;
        offer.price = null;
        offer.downPayment = null;
        offer.months = null;
        offer.terms = null;
        return;
      }

      offer.selectedVariantId = variantId;
      offer.price = null;
      offer.downPayment = null;
      offer.months = null;
      offer.terms = null;
    },
    UPDATE_SELECTED_COLOR: (
      state: IStateOffers,
      { id, color }: { id: number; color?: string | null }
    ): void => {
      const offer = state.offers.find((offer) => offer.productId == id);

      if (!offer) return;

      offer.selectedColor = color;
    },
  },
  actions: {
    setOffers: ({ commit }, payload: IStateOffer[]): void =>
      commit("SET_OFFERS", payload),
    updatePrice: ({ commit }, { id, price }): void =>
      commit("UPDATE_PRICE", { id, price }),
    updateDownPayment: (
      { commit },
      { id, downPayment, minDownPayment, maxDownPayment }
    ): void =>
      commit("UPDATE_DOWNPAYMENT", {
        id,
        downPayment,
        minDownPayment,
        maxDownPayment,
      }),
    updateTerms: ({ commit }, { id, terms }): void =>
      commit("UPDATE_TERMS", { id, terms }),
    updateMonths: ({ commit }, { id, months }): void =>
      commit("UPDATE_MONTHS", { id, months }),
    updateFirstPaymentDate: ({ commit }, { id, firstPaymentDate }): void =>
      commit("UPDATE_FIRST_PAYMENT_DATE", { id, firstPaymentDate }),
    updateSelectedVariant: ({ commit }, { id, variantId }): void =>
      commit("UPDATE_SELECTED_VARIANT", { id, variantId }),
    updateSelectedColor: ({ commit }, { id, color }): void =>
      commit("UPDATE_SELECTED_COLOR", { id, color }),
  },
  getters: {
    getOffers: (state: IStateOffers): IStateOffer[] => {
      return state.offers;
    },
  },
};
